import "./ScaffoldingInReading.module.css";
import Header from "@/reusable_sections/Header";
import ReadingHero from "./sections/ReadingHero";
import CompanyIntro from "./sections/CompanyIntro";
import ReadingCapabilities from "./sections/ReadingCapabilities";
import AccessSafety from "./sections/AccessSafety";
import Readingfaq from "./sections/Readingfaq";
import Finalcta from "./sections/Finalcta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInReadingPage() {
  return <div>
      <Header />
      <ReadingHero />
      <CompanyIntro />
      <ReadingCapabilities />
      <AccessSafety />
      <Readingfaq />
      <Finalcta />
      <Footer />
    </div>;
}